import State from '../core/State';
import Language from '../entity/Language';

export const setLanguage = (language: Language) => (state: State): State => ({
  ...state,
  language,
});
